import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '@/modules/core/app/services/Lang';

export class EstateDistributionSpecificType extends Enum {
  key!: string;
  value!: string;

  static PET_LUMP_SUM: EstateDistributionSpecificType = {
    key: 'pet_lump_sum',
    get value() {
      return Lang.t('guidancestep.pet-lump-sum');
    }
  };
}
